var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.disabled)?_c('div',[_vm._t("default")],2):_c('el-popover',_vm._g(_vm._b({attrs:{"popper-class":"tamara-base-popover"},scopedSlots:_vm._u([{key:"reference",fn:function(){return [_vm._t("reference")]},proxy:true}],null,true)},'el-popover',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }